import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { ITraderInfo } from "../interface/ITrader";
import { GetTraderParamModel } from "../model/common";
import traderService from "../service/TraderService";
import { RootState } from "../store/store";
import { logoutUser } from "./common";

export const resetTraders = createAction("traders/reset");

const _service = new traderService();

type SliceState = {
  value: ITraderInfo[];
  status: string;
  apiCallCount: number;
};
const initialState = {
  value: [],
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
} as SliceState;

export const getTradersAsync = createAsyncThunk(
  "traders/traders",
  async (params: GetTraderParamModel) => {
    const response = await _service.getTradersService(params);
    return response;
  }
);

export const tradersSlice = createSlice({
  name: "traders",
  initialState,
  reducers: {
    setTradersStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTradersAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getTradersAsync.fulfilled, (state: SliceState, action) => {
        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getTradersAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetTraders, () => {
        return initialState;
      });
  },
});

export const { setTradersStatus } = tradersSlice.actions;
export const hasMultipleCustomers = (state: RootState) =>
  state.traders && state.traders.value && state.traders.value.length > 1;
export const getTradersList = (state: RootState) => state.traders.value;
export const getTradersListTop1 = (state: RootState) =>
  state.traders.value && state.traders.value.length > 0
    ? state.traders.value[0]
    : [];
export const getTradersLoadingStatus = (state: RootState) =>
  state.traders.status;
export default tradersSlice.reducer;
